import React, { useEffect, useState } from 'react';
import Loader from '../components/Loader';
import Post from '../components/Post';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useParams, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { deletePost, fetchPost, registeredCard } from '../reducers/feed/feed.actions';
import { clearFeedActionCreator } from '../reducers/feed/feed.actionCreators';
import { selectCurrentPost } from '../reducers/feed/feed.selectors';
import { Button } from 'react-bootstrap';
import LockedSubscribeContent from './profile/LockedSubscribeContent';
import { SubscriptionIcon, GeryWarningIcon } from 'components/Icons';
import { toggleFollow } from 'reducers/profile/profile.actions';
import AddPaymentModal from 'components/AddPaymentModal';
import { ROOT } from 'constants/routes';

const SinglePost = (user) => {
  const [card, setCard] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const post = useSelector(selectCurrentPost);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { id } = useParams();
  const [show, setShow] = useState(false);
  const history = useHistory();

  useEffect(() => {
    dispatch(registeredCard())
      .then(card => setCard(card))
  }, []);
  useEffect(() => {
    if ((!post && !!id) || post.id !== Number(id)) {
      setIsLoading(true);
      dispatch(fetchPost(id))
        .catch(err => {
          console.log('fetch post error', err);
        })
        .finally(resp => {
          setIsLoading(false);
        });
    }
    return () => {
      dispatch(clearFeedActionCreator());
    };
  }, [id]);

  const onSubmit = () => {
    if (!isLoading) {
      setIsLoading(true);
      setShow(false);
      dispatch(toggleFollow(post?.user?.id))
        .then(() =>
          dispatch(fetchPost(id))
            .finally(() => setIsLoading(false))
        )
        .catch(err => {
          console.log('toggleFollow error', err);
        });
    }
  };

  const handlePostDelete = async (id) => {
    if (window.confirm(t('This action can not be undone. Are you sure you want to delete this post?'))) {
      setIsLoading(true);
      dispatch(deletePost(id))
        .finally(() => history.push(ROOT));
    }
  };

  const RemovedPostPopup = () => {
    return (
      <div className='remove-popup-main-container'>
        <div className="removed-pop">
          <div><GeryWarningIcon className='remove-popup-icon' /></div>

          <div className="removed-post-content">
            <p>{t(`Sorry, this content is not available right now`)}</p>
            <p>{t(`This post was removed by the owner`)}</p>
          </div>
        </div>
      </div>
    )
  }
  const FollowBtn = () => {
    return (
      <Button
        onClick={() => setShow(true)}
        className={'profile-sub-btn btn btn-light px-5 mt-0 ' + (post.following ? '' : 'unfollowing')}
        style={{ width: '100%', borderRadius: '32px' }}
      >
        <span className="profile-sub-icon">
          <SubscriptionIcon />
        </span>
        {t(post.following ? 'Unsubscribe' : 'subscribe_to_see_post')}
      </Button>
    );
  };

  return (
    <div className="mx-auto single-post-container">
      <Loader isLoadin={isLoading} height={311} size={60}>
        {post &&
          (post?.user?.id === user?.user?.id || post?.user?.following ? (
            <Post post={post} card={card} singlePostFollowed={post?.user?.following} handlePostDelete={handlePostDelete} />
          ) : (
            <div className="profile-locked-content">
              <LockedSubscribeContent post={post} files={post.files} FollowBtn={FollowBtn} />
            </div>
          ))}
        {!post && <RemovedPostPopup />}
      </Loader>
      {show && <AddPaymentModal card={card} user={post.user} show={show} onHide={() => setShow(false)} onSubmit={() => onSubmit(false)} />}
    </div>
  );
};

export default SinglePost;
